import React, { useEffect, useState } from "react";
import styles from "./home.module.css";
import {
  Box,
  Button,
  Link,
  Modal,
  TextField,
  TextareaAutosize,
  Tooltip,
  Typography,
  useMediaQuery,
} from "@mui/material";
import ApplyModal from "../Modal/ApplyModal";
import Head from "next/head";
import CloseIcon from "@mui/icons-material/Close";
import FindDivineModal from "../Modal/FindDivineModal";
import MembershipModal from "../Modal/MembershipModal";
import StudyChapterModal from "../Modal/StudyChapterModal";
import { getCookie, setCookie } from "../utils/cookie";
import Image from "next/image";
import { useRouter } from "next/router";
import MysteryBannerNew from "../MysteryBannerNew/MysteryBannerNew";

export default function Homes() {
  const router = useRouter();

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [newOpen, setNewOpen] = useState(false);
  const handleNewOpen = () => setNewOpen(true);
  const handleNewClose = () => setNewOpen(false);

  const [newSecOpen, setNewSecOpen] = useState(false);
  const [newSecOneOpen, setNewSecOneOpen] = useState(false);
  const [newSecTwoOpen, setNewSecTwoOpen] = useState(false);
  const [newSecThreeOpen, setNewSecThreeOpen] = useState(false);
  const handleNewSecOpen = () => setNewSecOpen(true);
  const handleNewSecOneOpen = () => setNewSecOneOpen(true);
  const handleNewSecTwoOpen = () => setNewSecTwoOpen(true);
  const handleNewSecThreeOpen = () => setNewSecThreeOpen(true);
  const handleOpenClose = () => setNewSecOpen(false);
  const handleOpenOneClose = () => setNewSecOneOpen(false);
  const handleOpenTwoClose = () => setNewSecTwoOpen(false);
  const handleOpenThreeClose = () => setNewSecThreeOpen(false);
  const [newwOpen, setNewwOpen] = useState(false);
  const handleNewwOpen = () => {
    setNewwOpen(true);
  };
  const [membershipOpen, setMembershipOpen] = useState(false);
  const memberfunc = () => {
    setMembershipOpen(true);
  };
  const [studychapOpen, setStudychapOpen] = useState(false);
  const studychapfunc = () => {
    setStudychapOpen(true);
  };

  // const openModal = () => setOpenModal(true);
  // const closeModal = () => setOpenModal(false);
  const [mdata, setMdata] = useState({});
  useEffect(() => {
    if (mdata && Object.keys(mdata).length > 0) {
      setNewOpen(true);
    }
  }, [mdata]);

  useEffect(() => {
    const cookie = getCookie("guest_id");
    if (!cookie) {
      const randomValue =
        Math.random().toString(36).substring(2, 16) +
        Math.random().toString(36).substring(2, 16);

      const expires = new Date();
      expires.setMonth(expires.getMonth() + 2);

      setCookie("guest_id", randomValue, { expires });
    }
  }, []);

  let subjects = [
    {
      id: 1,
      name: "CENTRAL DOCTRINE",
      image: "/image/central-doctrain-new/central_doc_homepage_sec_bg.webp",
      pageRouter: "central-doctrine",
      content:
        "Our school’s central doctrine outlines the Theurgic ritual praxis of our school. If you are interested in the Inner mysteries of our school and our activities and future plans this is the best place to start. We cover the science, ritual technology and overall methods of our work.  We syncretize ancient practices of Neoplatonic Theurgy with the breakthroughs in psychology, quantum biology, quantum mechanics and string theory in a new vision of ritual work.  There are many important differences as well as similarities to other mystery schools and to learn what sets our methods apart please take the time to review our central doctrine.",
    },
    {
      id: 2,
      name: "LAYMAN EXPLANATION",
      image: "/image/home-page-as-image2.webp",
      pageRouter: "layman-explanation",
      content:
        "Our school Layman is a Cosmic map of the different Archetypes, gods, goddesses and ritual symbolism central to the Theurgic practices of our school. We suggest you start with the Central Doctrine to get a definition of the different aspects and language you will encounter in review of the school Layman first. Once you have a grasp of these initial ideas, a review of the Layman symbolism will give you a deep narrative and doorway into the Cosmic ontology presented in this grand symbolic persona of the infinite.  The school Layman is a single map of the different uses of liturgy, both east, west and modern, giving you a vision of our work.",
    },
    {
      id: 3,
      name: "Mystery school",
      image: "/image/home-page-as-image3.webp",
      pageRouter: "central-doctrine",
      content:
        "The Inner Mystery School of Our Divine Infinite Being is a 15-month inner mystery ritual praxis grounded in the sacred art of Theurgy and aligned with the cycles of the Astrological Wheel. It is both a monthly membership offering and a structured spiritual path that unfolds through distinct cyclic initiations. Unlike traditional hierarchical systems, our grades are not markers of superiority but represent phases of personal integration and cosmic alignment. We believe spiritual attainment is a matter between the individual and the Divine, not something granted by external authority. Members receive access to our private member center, where they can explore video teachings and receive the ritual materials needed for each phase of the journey. Click to learn more about how to apply.",
    },

    {
      id: 4,
      name: "Divine Arcana Tarot",
      image: "/image/home-page-as-image4.webp",
      pageRouter: "divine-arcana-tarot",
      content:
        "The Divine Arcana Tarot is a 4 year collaboration between our teacher, Eddie, the occult artist Raju Sarkar and the assistance of different philosophers and religious practitioners of both eastern and western systems. We offer you the opportunity to engage the symbolic archetypal language of our Tarot here on our website for free. We offer the purchase of our deck, as well as training for professional readers in our school. We follow the format of ROTA or the Astrological Wheel of the Tarot in our work as other mystery schools, but we have included archetypal language in their meaning from both western and eastern sources.",
    },
    {
      id: 5,
      name: "Rota the wheel",
      image: "/image/home-page-as-image5.webp",
      pageRouter: "rota-the-wheel",
      content:
        "ROTA the Wheel is a symbolic encyclopedia of Astrological archetypes built upon the framework of the Tarot system of ritual and divination. This alchemy of archetypes is the central diagram that we use for the ritual Theurgy of our school.  Other schools use this framework as well, such as the Golden Dawn and Thelemic schools, but for us it is the central focus of all of our ritual praxis and visionary work.  Understanding how this symbolism works together in the Wheel (ROTA) will unlock the archetypal language of our Divine Arcana Tarot as well as other related systems such as the Rider Waite and the Thelemic Thoth Tarot.",
    },
    {
      id: 6,
      name: "Tarot Typology",
      image: "/image/home-page-as-image6.webp",
      pageRouter: "tarot-typology",
      content:
        "The School of Our Divine Infinite Being has incorporated Jungian themes into much of what we employ.  This you can see most directly in our central doctrine. Jung was a master of Typology and developed a system of psychological types that has grown into one of the most popular systems to date.  The Meyers Briggs foundation, based on the framework of Jung’s work, developed 16 archetypes that have found wide use in their personality test globally.  These 16 archetypes match the 16 court cards of the Tarot with such a precision there has been much literature written on the subject. Learn more about this here.",
    },

    // {
    //   id: 7,
    //   name: "Study Chapters ",
    //   image: "/image/home-page-as-image7.webp",
    //   pageRouter: "",
    //   modalOpen: "true",
    //   content: "The School of Our Divine Infinite Being, along with the outer school of Timothy Desmond. <a  href='https://www.psycheandsingularity.com' target='_blank'>https://www.psycheandsingularity.com </a>  will be creating study chapters in cities across the world. We currently have them going in Salt Lake City, UT and will be opening more. We share our plans in the Central Doctrine, but you can review our format and study guide here on this page.  We are reopening the Platonic Academies at meet ups across the world and invite you to participate in these study groups if you are local enough to join. We cover a myriad of subjects and reading materials, of high interest to those practicing the Divine Theurgy."
    // },
    {
      id: 7,
      name: "Psyche & Singularity",
      image: "/image/home-page-as-psyche-and-singularity.webp",
      pageRouter: "",
      content:
        "The School of Our Divine Infinite Being is honored to present a groundbreaking course by Professor Timothy Owen Desmond, Ph.D., renowned author of Psyche & Singularity: Jungian Psychology and Holographic String Theory. With over 15 hours of engaging instruction across 25 practical training sessions, this program takes you on a hero’s journey through philosophy, psychology, and physics, revealing the infinite nature of the cosmos and your place within it. Whether you have read his book or not, this course stands on its own as a clear and accessible path to applying these insights in your life. His ideas are deeply integrated with our school.",
    },
    {
      id: 8,
      name: "Calendar of Events",
      image: "/image/home-page-as-image8.webp",
      pageRouter: "calendar-of-events",
      content:
        "As the school grows we will be holding events in the United States, Europe and India.  We have initiations every Solstice and Equinox which are done in person for those that can make it to us and over Zoom for those that can not.  Every summer we will have a gathering on the Summer Solstice and a 7 day intensive every year in September. We will be listing all of the study chapters and their events as well as all the school events on this page, so be sure to bookmark it and come back often to see what we are up to!  We have current gatherings in Salt Lake City UT where we plan to open the first temple of the Divine Infinite Being.",
    },
    // {
    //   id: 9,
    //   name: "Calendar of Events New",
    //   image: "/image/home-page-as-image8.webp",
    //   pageRouter: "calendar-of-events-new",
    //   content: "As the school grows we will be holding events in the United States, Europe and India.  We have initiations every Solstice and Equinox which are done in person for those that can make it to us and over Zoom for those that can not.  Every summer we will have a gathering on the Summer Solstice and a 7 day intensive every year in September. We will be listing all of the study chapters and their events as well as all the school events on this page, so be sure to bookmark it and come back often to see what we are up to!  We have current gatherings in Salt Lake City UT where we plan to open the first temple of the Divine Infinite Being."
    // }
  ];
  const LearnMoreClickFunction = (item) => {
    console.log("modalOpen", item);
    if (
      item.id == 1 ||
      item.id == 2 ||
      item.id == 4 ||
      item.id == 5 ||
      item.id == 8 ||
      item.id == 6 ||
      item.id == 9
    ) {
      // window.open(item.pageRouter)
      // window.location.replace(item.pageRouter)
      window.location.href = item.pageRouter;
    } else if (item.id == 3) {
      memberfunc();
    } else {
      if (item.id !== 7) {
        setMdata(item);
      }
    }
    if (item.id == 7) {
      window.open("https://www.psycheandsingularity.com", "_blank");
    }
    if (item.modalOpen) {
      studychapfunc();
    }
  };
  const [showOtherBlocks, setShowOtherBlocks] = useState(false);
  useEffect(() => {
    const timer = setTimeout(() => {
      setShowOtherBlocks(true);
    }, 1000);
    return () => clearTimeout(timer);
  }, []);

  const isMobile = useMediaQuery("(max-width:600px)");
  const isTablet = useMediaQuery("(min-width:601px) and (max-width:900px)");

  let logoBanner = "/image/logobanner_desktop.webp";

  if (isMobile) {
    logoBanner = "/image/logobanner.webp";
  } else if (isTablet) {
    logoBanner = "/image/logobanner.webp";
  }

  const ShareTo = (platform, page, title) => {
    console.log(platform);

    let shareUrl = "";

    if (title === "Psyche & Singularity") {
      if (platform == "facebook") {
        shareUrl = window.location.href.includes("dev")
          ? `https://www.facebook.com/sharer/sharer.php?u=psycheandsingularity.com/${page}`
          : `https://www.facebook.com/sharer/sharer.php?u=psycheandsingularity.com/${page}`;
        console.log("facebook", shareUrl);
      }

      if (platform == "twitter")
        shareUrl = window.location.href.includes("dev")
          ? `https://twitter.com/intent/tweet?text=${encodeURIComponent(
              title
                .replace(/[^\w]/gi, "-")
                .replace(/--/g, "-")
                .replace("--", "-")
            )}&url=${encodeURIComponent(`psycheandsingularity.com/${page}`)}`
          : `https://twitter.com/intent/tweet?text=${encodeURIComponent(
              title
                .replace(/[^\w]/gi, "-")
                .replace(/--/g, "-")
                .replace("--", "-")
            )}&url=${encodeURIComponent(`psycheandsingularity.com/${page}`)}`;

      if (platform == "linkedin") {
        shareUrl = window.location.href.includes("dev")
          ? ` http://www.linkedin.com/shareArticle?mini=true&url=psycheandsingularity.com/${page}`
          : ` http://www.linkedin.com/shareArticle?mini=true&url=psycheandsingularity.com/${page}`;
        console.log("linkedin", shareUrl);
      }
    } else {
      if (platform == "facebook") {
        shareUrl = window.location.href.includes("dev")
          ? `https://www.facebook.com/sharer/sharer.php?u=dev.divineinfinitebeing.com/${page}`
          : `https://www.facebook.com/sharer/sharer.php?u=divineinfinitebeing.com/${page}`;
        console.log("facebook", shareUrl);
      }

      if (platform == "twitter")
        shareUrl = window.location.href.includes("dev")
          ? `https://twitter.com/intent/tweet?text=${encodeURIComponent(
              title
                .replace(/[^\w]/gi, "-")
                .replace(/--/g, "-")
                .replace("--", "-")
            )}&url=${encodeURIComponent(`dev.divineinfinitebeing.com/${page}`)}`
          : `https://twitter.com/intent/tweet?text=${encodeURIComponent(
              title
                .replace(/[^\w]/gi, "-")
                .replace(/--/g, "-")
                .replace("--", "-")
            )}&url=${encodeURIComponent(`divineinfinitebeing.com/${page}`)}`;

      if (platform == "linkedin") {
        shareUrl = window.location.href.includes("dev")
          ? ` http://www.linkedin.com/shareArticle?mini=true&url=dev.divineinfinitebeing.com/${page}`
          : ` http://www.linkedin.com/shareArticle?mini=true&url=divineinfinitebeing.com/${page}`;
        console.log("linkedin", shareUrl);
      }
    }
    let newWindow = window.open(shareUrl, platform, "height=600,width=500");
  };

  const [isDesktop, setIsDesktop] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsDesktop(window.innerWidth >= 1024);
    };

    handleResize();

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const goToPage = (path) => {
    router.push(path);
  };

  return (
    <>
      {/* {!isDesktop && ( */}
      <>
        <link
          rel="preload"
          href="/image/homeblockonebg_mobile.webp"
          as="image"
          type="image/webp"
        ></link>

        <link
          rel="preload"
          href="/image/homeblocktwo-bg-image2_new_mobile.webp"
          as="image"
          type="image/webp"
        />
        <link
          rel="preload"
          href="/image/homeblocktwo-bg-image1_new_mobile.webp"
          as="image"
          type="image/webp"
        />
      </>
      {/* // )} */}

      {/* {isDesktop && ( */}
      <>
        <link
          rel="preload"
          href="/image/homeblockonebg.webp"
          as="image"
          type="image/webp"
        />
        <link
          rel="preload"
          href="/image/logobanner_cropped.webp"
          as="image"
          type="image/webp"
        />

        <link
          rel="preload"
          href="/image/homeblocktwo-bg-image2_new.webp"
          as="image"
          type="image/webp"
        />
        <link
          rel="preload"
          href="/image/homeblocktwo-bg-image1_new.webp"
          as="image"
          type="image/webp"
        />
      </>
      {/* )} */}

      <Head>
        <title>Home | School of Our Divine Infinite Being</title>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0"
        ></meta>
        <meta
          name="keywords"
          content="Astrology, Tarot, Theurgy, Divination, Mystery School"
        ></meta>
        <meta
          name="description"
          content="Train as an Astrologer or Tarot reader at our Mystery School.  Learn Theurgy, explore Perennial Mandalism, and book divinatory readings."
        />
        <meta
          property="og:title"
          content="School of Our Divine Infinite Being | Astrology, Tarot, & Modern Ritual Theurgy Training"
        ></meta>
        <meta property="og:type" content="website"></meta>
        <meta
          property="og:image"
          content="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/TranscendentOG_image.webp"
        ></meta>
        <meta
          property="og:description"
          content="Explore transformative training in astrology, tarot, and modern ritual Theurgy at the School of Our Divine Infinite Being. Unlock your spiritual potential and gain profound insights into the mysteries of the universe with our expert-guided courses."
        ></meta>

        <meta property="og:image:width" content="1200"></meta>
        <meta property="og:image:height" content="627"></meta>
        <meta
          property="og:url"
          content="https://www.divineinfinitebeing.com"
        ></meta>

        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:url"
          content="https://www.divineinfinitebeing.com"
        />
        <meta
          name="twitter:title"
          content="School of Our Divine Infinite Being | Astrology, Tarot, & Modern Ritual Theurgy Training"
        />
        <meta
          name="twitter:description"
          content="Explore transformative training in astrology, tarot, and modern ritual Theurgy at the School of Our Divine Infinite Being. Unlock your spiritual potential and gain profound insights into the mysteries of the universe with our expert-guided courses."
        />
        <meta
          name="twitter:image"
          content="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/TranscendentOG_image.webp"
        />
        <meta
          property="og:image:alt"
          content="An illustration representing astrology, tarot cards, and ritual theurgy practices"
        />

        <link rel="canonical" href="https://www.divineinfinitebeing.com" />

        <style>
          {`
            /* Critical CSS for LCP element */
            .home_homeblockone__fT9wE { 
              background: url(/image/homeblockonebg.webp);
              background-position: right 0;
              background-repeat: no-repeat;
              border-radius: 0;
              background-size: cover;
              padding: 0 0 26px;
              margin-bottom: 0;
              min-height: 1px;
              border-top: 1px solid #000;
              contain: paint;
            }

            @media (max-width: 1699.98px) {
              .home_homeblockone__fT9wE {
                background-position: right -133px top !important;
              }
            }

            @media (max-width: 767.98px) {
            .home_homeblockone__fT9wE {
              background: url(/image/homeblockonebg_mobile.webp);
              background-position: right -1213px top !important;
              background-size: 2000px;
              contain: paint;
              }

            }

            .home_homeblockone__fT9wE img { 
              color: transparent;
              width: 100%;
              height: auto;
            } 


            
          `}
        </style>
      </Head>

      <div id="body" className="nodatadashboard">
        <div id="maincontent" className="maincontentinnerpage">
          {/* ===================== Soubhik Debnath =================================*/}

          {/* <!------homeblockone-------> */}
          <div className={styles.homeblockone}>
            <div className={styles.asmainwrapper}>
              <div className={styles.homeblockoneleft}>
                <span className={styles.bannerLogo}>
                  <span className={styles.logoviewlink} onClick={handleOpen}>
                    <Image
                      src="/image/viewicon.webp"
                      alt="View Icon"
                      width={400}
                      height={100}
                      style={{ width: "100%", height: "auto" }}
                      priority={true}
                      placeholder="blur"
                      blurDataURL="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUA"
                    />
                  </span>

                  <Image
                    src="/image/logobanner_cropped.webp"
                    alt="School of Our Divine Infinite Being Logo"
                    width={332}
                    height={332}
                    style={{ width: "100%", height: "auto" }}
                    priority={true}
                    placeholder="blur"
                    blurDataURL="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUA"
                  />
                </span>
                <h1 data-text="SCHOOL OF OUR DIVINE">SCHOOL OF OUR DIVINE </h1>
                <h2 data-text="infinite being">INFINITE BEING</h2>
                <h3>
                  Polytheistic Monism - Divine Theurgy - Oracle to the Gods
                </h3>
                <div
                  className={`${styles.bannerboxtxt} ${styles.bannerboxtxt_new}`}
                >
                  {/* <p>We train Astrologers, Tarot readers, offer a Mystery School of modern ritual Theurgy and membership in our religion practices of Perennial Mandalism. Please feel free to browse our website, we have hundreds of pages here including a full review of our Central Doctrine.</p> */}

                  <div
                    className={`${styles.click_central_D} ${styles.cmn_txt}`}
                  >
                    <div className={styles.bnnr_22jul_flx}>
                      {" "}
                      <p>
                        Be Introduced to our <span>Central Doctrine</span>
                      </p>{" "}
                      <button
                        className={styles.btnblack}
                        onClick={() => router.push("/central-doctrine")}
                      >
                        {" "}
                        Click here{" "}
                      </button>{" "}
                    </div>
                  </div>
                  <div
                    className={`${styles.click_div_arcana} ${styles.cmn_txt}`}
                  >
                    <div className={styles.bnnr_22jul_flx}>
                      {" "}
                      <p>See our full </p>
                      <p>color Divine</p>
                      <p>Arcana Tarot</p>{" "}
                      <button
                        className={styles.btnblack}
                        onClick={() => router.push("/divine-arcana-tarots")}
                      >
                        {" "}
                        Click here{" "}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <MysteryBannerNew/>

          {/* <!-- <-----------------homeblockb4two------------------> */}
          <div className={`${styles.homeblocktwo} ${styles.homeblockb4two}`}>
            <div className={styles.asmainwrapper}>
              <div className={styles.b4onecontainer_flex}>
                <div className={styles.b4one_left_sec}>
                  <div className={styles.b4one_left_div}>
                    <h4>
                      <strong data-text="Astrology and Tarot">
                        Astrology and Tarot{" "}
                      </strong>{" "}
                    </h4>
                    <h5>
                      {" "}
                      <span data-text="School and Certification">
                        {" "}
                        School and Certification
                      </span>
                    </h5>
                    {/* <h5><span data-text="">and Services</span></h5> */}
                    <p>
                      Discover your path to becoming a certified astrologer and
                      tarot reader—
                      <span>
                        {" "}
                        click here to explore our in-depth training and
                        certification programs!
                      </span>{" "}
                    </p>
                    <button
                      className={styles.btnblack}
                      onClick={() =>
                        router.push("/tarot-astrology-certification")
                      }
                    >
                      See School Details
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* ===================== Soubhik Debnath =================================*/}

          

          {/* ===================== biswarup =================================*/}
          <div className={styles.block2_full_width}>
            <div className={styles.homeblocktwo}>
              {/* <div className={styles.asmainwrapper}> */}
              <div className={styles.countDiv}>
                <span className={styles.column}>
                  {/* <div className={styles.block2_right_red_sec}>
                      <div className={`${styles.col4} ${styles.h - 100} ${styles.homeblocktwocol1}`}>
                        <p>"Become a Professional <br /> Divination Consultant,</p>
                        <p> <Link href='/tarot-astrology-certification'><span className={styles.btnYellow} >click</span></Link> to see our 24 week courses!"</p>
                      </div>
                    </div> */}

                  <div
                    className={`${styles.block2_left_green_sec} ${styles.block2_left_purple_sec}`}
                  >
                    <div
                      className={`${styles.col4} ${styles.h - 100} ${
                        styles.homeblocktwocol2
                      }`}
                    >
                      <p>
                        Learn about our <br /> Religious Practices as <br />
                        <span>Perennial Mandalins</span>
                      </p>
                      <span
                        title="Learn more about our spiritual tradition"
                        className={`${styles.btnblack} ${styles.descriptive_linktext}`}
                        onClick={() => goToPage("/perennial-mandalism")}
                      >
                        More about Perennial Mandalism
                      </span>
                    </div>
                  </div>

                  <div
                    className={`${styles.block2_left_green_sec} ${styles.block2_left_green_sec_new}`}
                  >
                    <div
                      className={`${styles.col4} ${styles.h - 100} ${
                        styles.homeblocktwocol2
                      }`}
                    >
                      <p>
                        MYSTERY SCHOOL <br />
                        <span>MEMBERSHIP</span>
                      </p>

                      {/* <Button
                          className={styles.btnblack} onClick={() => memberfunc()}
                        >Apply Now</Button> */}
                      <span
                        className={`${styles.btnblack} ${styles.descriptive_linktext}`}
                        onClick={() => memberfunc()}
                      >
                        Learn More
                      </span>
                    </div>
                  </div>
                </span>
              </div>
              {/* </div> */}
            </div>
          </div>

          {/* ===================== krishnendu =================================*/}
          <div className={styles.homeblockfive}>
            <div
              className={`${styles.countDiv} ${styles.titleblock} ${styles.withsubtitle}`}
            >
              <span className={styles.column}>
                <div className={`${styles.col12} ${styles.bgifive}`}>
                  <h6>School of Divine Infinite Being</h6>
                  <p>
                    Please click on one of the following subjects to learn more
                    about the foundations of our Mystery School Tradition.
                  </p>
                </div>
              </span>
            </div>

            {/* ===================== krishnendu =================================*/}
            <div className={styles.asmainwrapper}>
              <div
                className={`${styles.countDiv} ${styles.homeblockfivecontent}`}
              >
                <div className={styles.column}>
                  {subjects.map((item) => (
                    <div
                      className={
                        `${styles.col6} ${styles.singleblock} ${styles["h-100"]} ` +
                        (item.name == "Psyche & Singularity"
                          ? styles.highlightPsyche
                          : "")
                      }
                      key={item.id}
                    >
                      <div className={styles.singleblockcontent}>
                        <div className={styles.imagewrapperclswrapper}>
                          <div className={styles.imagewrappercls}>
                            {/* <img src={`${item.image}`} alt={item.name} height={'100%'} width={'100%'} /> */}
                            <Image
                              src={`${item.image}`}
                              alt={item.name}
                              width={400} // Specify the width in pixels
                              height={100} // Specify the height in pixels
                              style={{ width: "100%", height: "100%" }} // Apply dynamic width and maintain aspect ratio
                              priority={false} // Prioritize this image
                              placeholder="blur"
                              blurDataURL="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUA"
                            />
                          </div>
                        </div>
                        <div className={styles.block_text_wrapper}>
                          <p>{item.name}</p>
                          <span
                            dangerouslySetInnerHTML={{ __html: item.content }}
                          ></span>
                          <div className={styles.socialmedia_sharewrap_dark}>
                            <Tooltip title="Share on Facebook" arrow>
                              <Image
                                src="/image/fb_icon_dark.webp"
                                alt="Facebook Icon"
                                width={100}
                                height={100}
                                priority={false}
                                onClick={() =>
                                  ShareTo(
                                    "facebook",
                                    item.pageRouter,
                                    item.name
                                  )
                                }
                                style={{ cursor: "pointer" }} // Optional for better UX
                                placeholder="blur"
                                blurDataURL="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUA"
                              />
                            </Tooltip>

                            <Tooltip title="Share on Twitter" arrow>
                              <Image
                                src="/image/twitter_icon_dark.webp"
                                alt="Twitter Icon"
                                width={100}
                                height={100}
                                priority={false}
                                onClick={() =>
                                  ShareTo("twitter", item.pageRouter, item.name)
                                }
                                style={{ cursor: "pointer" }}
                                placeholder="blur"
                                blurDataURL="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUA"
                              />
                            </Tooltip>

                            <Tooltip title="Share on LinkedIn" arrow>
                              <Image
                                src="/image/linkedin_icon_dark.webp"
                                alt="LinkedIn Icon"
                                width={100}
                                height={100}
                                priority={false}
                                onClick={() =>
                                  ShareTo(
                                    "linkedin",
                                    item.pageRouter,
                                    item.name
                                  )
                                }
                                style={{ cursor: "pointer" }}
                                placeholder="blur"
                                blurDataURL="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUA"
                              />
                            </Tooltip>
                          </div>
                          <span
                            className={`${styles.btnblack} ${styles.buttonLink} `}
                            onClick={() => LearnMoreClickFunction(item)}
                          >
                            Learn More
                          </span>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* ===================== souvik =================================*/}

            {/* ===================== souvik =================================*/}
          </div>

          {/* </>
          )} */}
        </div>
      </div>
      {/* =============== wheel modal ================ */}

      {showOtherBlocks && (
        <>
          <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            className="banner_modal_main"
          >
            <Box className="banner_modal_box">
              <Typography
                id="modal-modal-description"
                sx={{ mt: 2 }}
                className="modal_banner"
                component="div"
              >
                <div className="sub_modal_banner">
                  <span className="close_btn" onClick={handleClose}>
                    <CloseIcon />
                  </span>
                  {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/assets/images/logobanner.webp" alt="bannerLogo" /> */}
                  {/* <img alt="School of Our Divine Infinite Being Logo" src="/image/logobanner.webp" height={'100%'} width={'100%'} /> */}

                  <Image
                    src={logoBanner}
                    alt="bannerLogo"
                    width={400} // Specify the width in pixels
                    height={100} // Specify the height in pixels
                    style={{ width: "100%", height: "100%" }} // Apply dynamic width and maintain aspect ratio
                    priority={false} // Prioritize this image
                    placeholder="blur"
                    blurDataURL="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUA"
                  />
                </div>
              </Typography>
            </Box>
          </Modal>

          <Modal
            open={newOpen}
            onClose={handleNewClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            className={styles.banner_modal_main}
          >
            <Box className={styles.banner_modal_box_new}>
              <Typography
                component="div"
                id="modal-modal-description"
                sx={{ mt: 2 }}
                className={styles.modal_banner_new}
              >
                <div className={styles.sub_modal_banner}>
                  <span className={styles.close_btn} onClick={handleNewClose}>
                    <CloseIcon />
                  </span>
                  {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/assets/images/logobanner.webp" alt="bannerLogo" /> */}
                  {/* <img src="/image/logobanner.webp" alt="School of Our Divine Infinite Being Logo" height={'100%'} width={'100%'} /> */}
                  <Image
                    src="/image/logobanner_cropped.webp"
                    alt="School of Our Divine Infinite Being Logo"
                    width={400} // Specify the width in pixels
                    height={100} // Specify the height in pixels
                    style={{ width: "100%", height: "auto" }} // Apply dynamic width and maintain aspect ratio
                    priority={false}
                    placeholder="blur"
                    blurDataURL="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUA"
                  />

                  <p className={styles.modal_commingsoon}>Coming soon</p>
                </div>
              </Typography>
            </Box>
          </Modal>

          <Modal
            open={newSecOpen}
            onClose={handleOpenClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            className={styles.banner_modal_main}
          >
            <Box className={styles.banner_modal_box_new_sec}>
              <Typography
                component="div"
                id="modal-modal-description"
                sx={{ mt: 2 }}
                className={styles.modal_banner_new_one}
              >
                <div className={styles.sub_modal_banner_new}>
                  <span className={styles.close_btn} onClick={handleOpenClose}>
                    <CloseIcon />
                  </span>
                  <div className={styles.block2_modal_main_wrp}>
                    <div className={styles.block2_modal_sub_wrp}>
                      <h2>ARCHETYPAL ASTROLOGY CERTIFICATION</h2>
                    </div>
                    <div className={styles.form_sec}>
                      <form>
                        <TextField
                          className={styles.input_field}
                          id="outlined-basic"
                          label="Name"
                          variant="outlined"
                        />

                        <TextField
                          className={styles.input_field}
                          id="outlined-basic"
                          label="Email"
                          variant="outlined"
                        />

                        <TextField
                          className={styles.input_field}
                          id="outlined-basic"
                          label="Phone No"
                          variant="outlined"
                        />
                        <TextField
                          className={styles.input_field}
                          name="Message"
                          label="Message"
                          multiline
                          rows={3}
                        />
                      </form>
                    </div>
                    <Button className={styles.modal_form_btn}>
                      <span>submit</span>
                    </Button>
                    <p className={styles.modal_p_sec}>
                      <span>
                        Enrollment begins June 2022 / Classes start September
                        2022,
                      </span>{" "}
                      please fill out the above to be added to the Class
                      Information Newsletter
                    </p>
                  </div>
                </div>
              </Typography>
            </Box>
          </Modal>

          <Modal
            open={newSecOneOpen}
            onClose={handleOpenOneClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            className={styles.banner_modal_main}
          >
            <Box className={styles.banner_modal_box_new_sec}>
              <Typography
                component="div"
                id="modal-modal-description"
                sx={{ mt: 2 }}
                className={styles.modal_banner_new_one}
              >
                <div className={styles.sub_modal_banner_new}>
                  <span
                    className={styles.close_btn}
                    onClick={handleOpenOneClose}
                  >
                    <CloseIcon />
                  </span>
                  <div className={styles.block2_modal_main_wrp}>
                    <div className={styles.block2_modal_sub_wrp}>
                      <h2>TAROT DIVINATION CERTIFICATION</h2>
                    </div>
                    <div className={styles.form_sec}>
                      <form>
                        <TextField
                          className={styles.input_field}
                          id="outlined-basic"
                          label="Name"
                          variant="outlined"
                        />

                        <TextField
                          className={styles.input_field}
                          id="outlined-basic"
                          label="Email"
                          variant="outlined"
                        />

                        <TextField
                          className={styles.input_field}
                          id="outlined-basic"
                          label="Phone No"
                          variant="outlined"
                        />
                        <TextField
                          className={styles.input_field}
                          name="Message"
                          label="Message"
                          multiline
                          rows={3}
                        />
                      </form>
                    </div>
                    <Button className={styles.modal_form_btn}>
                      <span>submit</span>
                    </Button>
                    <p className={styles.modal_p_sec}>
                      <span>
                        Enrollment begins June 2022 / Classes start September
                        2022,
                      </span>{" "}
                      please fill out the above to be added to the Class
                      Information Newsletter
                    </p>
                  </div>
                </div>
              </Typography>
            </Box>
          </Modal>

          <Modal
            open={newSecTwoOpen}
            onClose={handleOpenTwoClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            className={styles.banner_modal_main}
          >
            <Box className={styles.banner_modal_box_new_sec}>
              <Typography
                component="div"
                id="modal-modal-description"
                sx={{ mt: 2 }}
                className={styles.modal_banner_new_one}
              >
                <div className={styles.sub_modal_banner_new}>
                  <span
                    className={styles.close_btn}
                    onClick={handleOpenTwoClose}
                  >
                    <CloseIcon />
                  </span>
                  <div className={styles.block2_modal_main_wrp}>
                    <div className={styles.block2_modal_sub_wrp}>
                      <h2>MYSTERY SCHOOL MEMBERSHIP</h2>
                    </div>
                    <div className={styles.form_sec}>
                      <form>
                        <TextField
                          className={styles.input_field}
                          id="outlined-basic"
                          label="Name"
                          variant="outlined"
                        />

                        <TextField
                          className={styles.input_field}
                          id="outlined-basic"
                          label="Email"
                          variant="outlined"
                        />

                        <TextField
                          className={styles.input_field}
                          id="outlined-basic"
                          label="Phone No"
                          variant="outlined"
                        />
                        <TextField
                          className={styles.input_field}
                          name="Message"
                          label="Message"
                          multiline
                          rows={3}
                        />
                      </form>
                    </div>
                    <Button className={styles.modal_form_btn}>
                      <span>submit</span>
                    </Button>
                    <p className={styles.modal_p_sec}>
                      <span>
                        Enrollment begins June 2022 / Classes start September
                        2022,
                      </span>{" "}
                      please fill out the above to be added to the Class
                      Information Newsletter
                    </p>
                  </div>
                </div>
              </Typography>
            </Box>
          </Modal>

          <Modal
            open={newSecThreeOpen}
            onClose={handleOpenThreeClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            className={styles.banner_modal_main}
          >
            <Box className={styles.banner_modal_box_new_sec}>
              <Typography
                component="div"
                id="modal-modal-description"
                sx={{ mt: 2 }}
                className={styles.modal_banner_new_one}
              >
                <div className={styles.sub_modal_banner_new}>
                  <span
                    className={styles.close_btn}
                    onClick={handleOpenThreeClose}
                  >
                    <CloseIcon />
                  </span>
                  <div className={styles.block2_modal_main_wrp}>
                    <div className={styles.block2_modal_sub_wrp}>
                      <h2>PHOTONIC METHOD ENERGY MEDICINE</h2>
                    </div>
                    <div className={styles.form_sec}>
                      <form>
                        <TextField
                          className={styles.input_field}
                          name="Name"
                          label="Name"
                        />

                        <TextField
                          className={styles.input_field}
                          name="Email"
                          label="Email"
                        />

                        <TextField
                          className={styles.input_field}
                          name="Phone No"
                          label="Phone No"
                        />
                        <TextField
                          className={styles.input_field}
                          name="Message"
                          label="Message"
                          multiline
                          rows={3}
                        />
                      </form>
                    </div>
                    <Button className={styles.modal_form_btn}>
                      <span>submit</span>
                    </Button>
                    <p className={styles.modal_p_sec}>
                      <span>
                        Enrollment begins June 2022 / Classes start September
                        2022,
                      </span>{" "}
                      please fill out the above to be added to the Class
                      Information Newsletter
                    </p>
                  </div>
                </div>
              </Typography>
            </Box>
          </Modal>

          {newwOpen && (
            <FindDivineModal newwOpen={newwOpen} setNewwOpen={setNewwOpen} />
          )}

          {membershipOpen ? (
            <MembershipModal
              membershipOpen={membershipOpen}
              setMembershipOpen={setMembershipOpen}
            />
          ) : (
            ""
          )}

          {studychapOpen && (
            <StudyChapterModal
              studychapOpen={studychapOpen}
              setStudychapOpen={setStudychapOpen}
            />
          )}
        </>
      )}
    </>
  );
}
